import React, {useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {ErrorMessage} from '@hookform/error-message'
import {ControlledSelect} from 'common/Select'
import Help from 'form/Help'

import {noop} from 'utils'
import PropTypes from 'prop-types'

export default function Select({
	id,
	name,
	label,
	rules,
	help,
	observe = noop,
	...props
}: any) {

	const {control, errors, watch, readOnly}: any = useFormContext()
	const watched = watch(name, '')

	useEffect(() => observe(watched), [observe, watched])
	return (
		<div className="form-group">
			<label htmlFor={name}>
				{label}
				<Help help={help}/>
			</label>
			<ControlledSelect
				{...props}
				isDisabled={readOnly}
				id={id}
				name={name}
				rules={rules}
				control={control}
			/>
			<ErrorMessage
				name={name}
				errors={errors}
				render={({ message }) => (
					<div className="invalid-feedback d-block">{message}</div>
				)}
			/>
		</div>
	)
}

Select.propTypes = {
	id: PropTypes.string,
	name: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired
}
